import axios from 'axios';

const timestampURL = `${process.env.VUE_APP_INDIGO_API_URL}/api/v1/analytics/time.php`;

const gaEvent = (category, action, label) => {
  axios.get(timestampURL).then((time) => {
    dataLayer.push({
      event: 'gtm.event',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventTimeStamp: time.data,
    });

    if (process.env.NODE_ENV === 'development') {
      // console.log({
      //   event: 'gtm.event',
      //   eventCategory: category,
      //   eventAction: action,
      //   eventLabel: label,
      //   eventTimeStamp: time.data,
      // });
    }
  });
};

const gaPageView = (value) => {
  axios.get(timestampURL).then((time) => {
    dataLayer.push({
      event: 'gtm.pageview',
      pageview: value,
      eventTimeStamp: time.data,
    });

    if (process.env.NODE_ENV === 'development') {
      // console.log({
      //   event: 'gtm.pageview',
      //   pageview: value,
      //   eventTimeStamp: time.data,
      // });
    }
  });
};

export default { gaEvent, gaPageView };
